const SvgMinus = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}><rect width={20} height={1.5} y={0.25} fillRule="evenodd" rx={0.75} transform="translate(8 17)" /></svg>;
export default SvgMinus;